import React, { useContext, useEffect } from "react";
import style from "./PaymentSection.module.css";
import { Radio, RadioGroup } from "@mui/material";
import CIcon from "@coreui/icons-react";
import { cilCreditCard } from "@coreui/icons";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import P from "components/P";
import { AuthContext } from "providers/AuthProvider";

const PaymentSection = ({ isMobile, paymentMethod, onPaymentMethodClick, user, }) => {
  const { t } = useTranslation();
  const { userInfo } = useContext(AuthContext);

  const accountNo =
    user?.metadata &&
      "bank" in user?.metadata &&
      "account" in user?.metadata &&
      "owner" in user?.metadata
      ? `${user.metadata.bank} ${user.metadata.account}`
      : "관리자에게 문의 부탁드립니다.";
  // : "국민은행 991501-01-243185";
  const copyBtnClick = () => {
    navigator.clipboard.writeText(accountNo);
    toast.success("클립보드에 복사되었습니다.", {
      autoClose: 1000,
      position: toast.POSITION.BOTTOM_CENTER,
    });
  };


  return (
    <div className={style.container}>
      <P size={23} weight={900}>
        {t("결제수단")}
      </P>
      <div className={style.paymentSelection}>
        <RadioGroup value="TRUE">
          <div className={style.radioOption}>
            <Radio
              name="productDisplay"
              value="TRUE"
              color="primary"
              size="small"
            />
            <P size={18} weight={900}>
              가상계좌
            </P>
          </div>
        </RadioGroup>

        <div className={style.paymentMethod} onClick={onPaymentMethodClick}>
          <div className={style.methodInfo}>
            {/* <CIcon icon={cilCreditCard} size="lg" /> */}
            <P size={18} weight={600}>
              {accountNo}
            </P>
            <P size={18} weight={600} color={"#A1A1A1"}>
              {`(예금주 : ${"주식회사 푸푸"})`}
            </P>
            <button
              style={{
                border: "1px solid #9F9F9F",
                height: "fit-content",
                backgroundColor: "white",
              }}
              onClick={copyBtnClick}
            >
              <P color={"#5B5B5B"} weight={600}>
                계좌번호 복사
              </P>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSection;
